;(function () {
  const selectors = {
    price: '.component__product-card__info__price',
    quickAddBtn: '[data-quick-add-btn]',
    quickAddVariants: '.component__product-card__info__quick-add__variants',
    quickAddVariantInput: 'input[data-quick-add-variant-input]',
    productRecommendations: '.product-recommendations',
    bundleProductsData: '.bundle-products-data',
  }

  class QuickAdd {
    constructor(btns) {
      this.btns = btns
    }

    getBundleProducts(productId) {
      const bundleDataElement = document.querySelector(
        `${selectors.bundleProductsData}[data-product-id="${productId}"]`,
      )

      if (!bundleDataElement) {
        return null
      }

      try {
        const parsed = JSON.parse(bundleDataElement.textContent)
        return parsed
      } catch (err) {
        return null
      }
    }

    async addBundleProductsToCart(bundleProducts, quantity = 1) {
      if (!bundleProducts || !bundleProducts.bundleProducts) {
        return false
      }

      try {
        // Prepare all bundle products for a single batch request
        const items = bundleProducts.bundleProducts.map((bundleProduct) => ({
          id: bundleProduct.selected_or_first_available_variant.id,
          quantity: quantity,
        }))

        // Create config for batch add to cart
        const config = {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          method: 'POST',
          body: JSON.stringify({ items }),
        }

        const response = await fetch(`/cart/add.js`, config)
        const responseData = await response.json()

        if (responseData.status) {
          // Don't throw error, just log it and return false
          return false
        }

        return true
      } catch (err) {
        // Don't throw error, just return false
        return false
      }
    }

    async checkVariantQuantity(variantId) {
      try {
        const res = await fetch('/cart.js')
        const data = await res.json()

        const items = data.items

        if (!data.items.length) {
          return true
        }

        const item = items.filter(
          (item) => item.variant_id === parseInt(variantId),
        )[0]

        if (!item) {
          return 0
        }

        return item.quantity
      } catch (err) {
        console.log(err)
      }
    }

    async addToCart(btn, variantId, variantType) {
      const productId = btn.dataset.productId
      const bundleProducts = this.getBundleProducts(productId)

      // Check if this is a bundle product FIRST, before any other processing
      if (bundleProducts && bundleProducts.bundleProducts) {
        btn.textContent = 'Adding...'

        try {
          // Always proceed with bundle product processing
          await this.addBundleProductsToCart(bundleProducts, 1)

          // Calculate total price for conversion tracking
          let totalPrice = 0
          bundleProducts.bundleProducts.forEach((bundleProduct) => {
            totalPrice +=
              bundleProduct.selected_or_first_available_variant.price * 1
          })

          try {
            if (window.rfd) {
              if (typeof reChargeCartJS !== 'undefined') {
                window.rfd.renderCart(false, reChargeCartJS)
              } else {
                window.rfd.renderCart(false)
              }
            }
          } catch (e) {
            // Cart render error ignored
          }
        } catch (error) {
          // Completely suppress all errors for bundle products
        }

        // Always complete the process for bundle products
        this.reset(btn, variantType)
        return
      }

      // Original single product logic
      btn.textContent = 'Adding...'

      const quantity = await this.checkVariantQuantity(variantId)

      if (quantity >= 5) {
        if (window.rfd) {
          if (typeof reChargeCartJS !== 'undefined') {
            window.rfd.renderCart(false, reChargeCartJS)
          } else {
            window.rfd.renderCart(false)
          }
        }

        return this.reset(btn, variantType)
      }

      const body = {
        id: variantId,
        quantity: 1,
      }

      if (btn.getAttribute('data-is-hazmat')) {
        body.properties = {
          hazmat:
            'This item is considered hazmat. Your order will ship by Ground.',
        }
      }

      try {
        let __add = await fetch('/cart/add.js', {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'POST',
          body: JSON.stringify(body),
        }).then((d) => d.json())

        if (window.rfd) {
          if (typeof reChargeCartJS !== 'undefined') {
            window.rfd.renderCart(false, reChargeCartJS)
          } else {
            window.rfd.renderCart(false)
          }
        }

        this.reset(btn, variantType)
      } catch (err) {
        console.log(err)
        this.innerText = 'Add to Bag'
      }
    }

    reset(btn, variantType) {
      const infoContainer = btn.parentElement.parentElement
      const variantsContainer = infoContainer.querySelector(
        selectors.quickAddVariants,
      )
      const price = infoContainer.querySelector(selectors.price)
      const variantInputs = infoContainer.querySelectorAll(
        selectors.quickAddVariantInput,
      )

      // reset legend name if selecting shade

      // reset price
      if (price) {
        price.innerHTML = price.dataset.defaultPrice
      }

      // reset variant inputs
      if (variantInputs.length) {
        for (let i = 0; i < variantInputs.length; i++) {
          variantInputs[i].checked ? (variantInputs[i].checked = false) : null
        }
      }

      // reset button text, reset variant id, reset variant container
      if (variantType) {
        if (variantType === 'shade') {
          btn.dataset.quickAddVariantId = ''
          btn.innerText = 'Select Shade'
        } else if (variantType === 'size') {
          btn.dataset.quickAddVariantId = ''
          btn.innerText = 'Select Size'
        }
        variantsContainer.classList.remove('active')
      } else {
        btn.innerText = 'Add to Bag'
      }

      // reset cancel
      btn.dataset.quickAddCancel = 'false'
    }

    handleVariantChange(e, btn) {
      e.preventDefault()
      const infoContainer = btn.parentElement.parentElement
      const price = infoContainer.querySelector(selectors.price)

      price.innerHTML = e.target.dataset.variantPrice
      btn.dataset.quickAddVariantId = e.target.value
      btn.dataset.quickAddCancel = 'false'
      btn.innerText = 'Add to Bag'
    }

    showVariants(btn, type) {
      const quickAddContainer = btn.parentElement

      if (type === 'shade' || type === 'size') {
        const quickAddVariantInputs = quickAddContainer.querySelectorAll(
          selectors.quickAddVariantInput,
        )

        for (let i = 0; i < quickAddVariantInputs.length; i++) {
          quickAddVariantInputs[i].addEventListener('change', (e) =>
            this.handleVariantChange(e, btn),
          )
        }
      } else {
        return
      }

      btn.innerText = 'Cancel'
      btn.dataset.quickAddCancel = 'true'
      quickAddContainer
        .querySelector(selectors.quickAddVariants)
        .classList.add('active')
    }

    onBtnClick(e) {
      e.preventDefault()
      let btn = e.target
      const variantType = btn.dataset.quickAddVariantType
      let variantId = btn.dataset.quickAddVariantId

      if (btn.dataset.quickAddCancel === 'true') {
        return this.reset(btn, variantType)
      }

      if (variantId && variantId.length) {
        return this.addToCart(btn, variantId, variantType)
      }

      this.showVariants(btn, variantType)
    }

    attachBtnListeners() {
      let _this = this

      document.addEventListener('click', function (e) {
        if (e.target.hasAttribute('data-quick-add-btn')) {
          _this.onBtnClick(e)
        }
      })
    }

    init() {
      this.attachBtnListeners()
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    new QuickAdd().init()
  })
})()
